'use strict';

const { captureException } = require('../../analytics/sentry');
var Promise = require('bluebird');
var loadMarketingTasks = require('./loadMarketingTasks');
var loadMarketingMustaches = require('./loadMarketingMustaches');
var renderMarketingTasks = require('./renderMarketingTasks');
var mappingModules = require('./mappingModules');

module.exports = function () {
  var isAdvancedReview = $('body').hasClass('review-advanced');
  var projectTaskUrl = $('.marketing-checklist').attr('data-project-url');
  var tasksPromise;
  var mustachesPromise;

  mappingModules();

  mustachesPromise = loadMarketingMustaches(isAdvancedReview);

  if ($('#dashboard').hasClass('generating-report')) {
    tasksPromise = new Promise(function (resolve, reject) {
      $('#dashboard').on('generationComplete', function () {
        resolve(loadMarketingTasks(projectTaskUrl));
      });
    });
  } else {
    tasksPromise = loadMarketingTasks(isAdvancedReview ? projectTaskUrl : null);
  }

  Promise.all([
    mustachesPromise,
    tasksPromise
  ])
    .spread(function (mustaches, tasks) {
      renderMarketingTasks(mustaches, tasks, isAdvancedReview);
    })
    .catch(function (err) {
      return captureException(err, {
        extra: {
          isAdvanced: isAdvancedReview,
          projectUrl: projectTaskUrl
        }
      });
    });
};
